module.exports = __webpack_public_path__ + "static/media/WebApp-small.bd2426e4.jpg";